import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import es from './locales/es.json'

const resources = {
  en: {
    translation: en,
  },
  es: {
    translation: es,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: import.meta.env.DEV,

    // Language detection options
    detection: {
      order: ['navigator', 'localStorage', 'sessionStorage', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Custom language mapping
    load: 'languageOnly', // Only use language code, not region
    
    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation'],

    // React specific options
    react: {
      useSuspense: false,
    },
  })

// Custom language detection logic
const detectedLanguage = navigator.language || navigator.languages?.[0] || 'en'
const languageCode = detectedLanguage.split('-')[0].toLowerCase()

// Set Spanish for Spanish browsers, English for everything else
if (languageCode === 'es') {
  i18n.changeLanguage('es')
} else {
  i18n.changeLanguage('en')
}

export default i18n